import logo from "../../images/logoblack.png";
import styled from "styled-components";
const Copntainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CopyRight = styled.p`
  font-size: 9px;
  letter-spacing: 2px;
`;
function Footer() {
  return (
    <Copntainer>
      <img src={logo} width={"50px"} alt="" />
      <CopyRight>Copyright &Copy; {new Date().getFullYear()}</CopyRight>
    </Copntainer>
  );
}

export default Footer;
